import { render, staticRenderFns } from "./ScriveEditSigningPartyFieldPlacement.vue?vue&type=template&id=c1b385ca&scoped=true&"
import script from "./ScriveEditSigningPartyFieldPlacement.vue?vue&type=script&lang=ts&"
export * from "./ScriveEditSigningPartyFieldPlacement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b385ca",
  null
  
)

export default component.exports